export const ENGAGEMENT_CHIPS = [
    'Strong participation',
    'Steady focus',
    'Needed encouragement',
    'Easily distracted today',
];

const GROUPS = {
    foundational_reading: {
        name: 'Foundational Reading',
        activities: [
            { key: 'letters_pron', label: 'Letters & pronunciation', placeholder: 'Which letters? e.g. "Qaf, Daad, Saad"' },
            { key: 'harakat', label: 'Harakat practice', placeholder: 'Which / which words? e.g. "Fatha & Damma on bilabial letters"' },
            { key: 'sukoon_connect', label: 'Sukoon & connecting letters', placeholder: 'Which letters? e.g. "Seen + Meem connection"' },
            { key: 'madd_basics', label: 'Madd basics', placeholder: 'Which examples? e.g. "Madd Tabee\'i in ا و ي"' },
            { key: 'word_building', label: 'Word building / workbook page', placeholder: 'Page + book? e.g. "page 22, Noorani Qaeda"' },
            { key: 'short_surah_practice', label: 'Short surah practice', placeholder: 'Which surah / verses? e.g. "Al-Fatiha"' },
        ],
        homework: [
            { key: 'repeat_sheikh', label: 'Repeat after the sheikh', placeholder: 'Link / surah? e.g. "Al-Fatiha audio"' },
            { key: 'app_practice', label: 'Practice on app / Wordwall', placeholder: 'Link? e.g. "Wordwall: harakat practice"' },
            { key: 'review_letters', label: 'Review letters / words', placeholder: 'What to review? e.g. "Sad and Daad letters"' },
            { key: 'read_workbook', label: 'Read workbook page', placeholder: 'Page? e.g. "page 23, Noorani Qaeda"' },
        ],
    },
    memorization: {
        name: 'Memorization',
        activities: [
            { key: 'new_mem', label: 'New memorization', placeholder: 'Which surah / verses? e.g. "Al-Mulk, verses 1-10"' },
            { key: 'rev_recent', label: 'Revision — recent', placeholder: 'Revise what? e.g. "Surah An-Naba"' },
            { key: 'rev_older', label: 'Revision — older portions', placeholder: 'Which juz? e.g. "Juz 30"' },
            { key: 'tajweed_mem', label: 'Tajweed during memorization', placeholder: 'Which rule? e.g. "Madd Tabee\'i"' },
            { key: 'recite_from_memory', label: 'Recitation from memory (test)', placeholder: 'Which verses? e.g. "Al-Fatiha + Al-Ikhlas"' },
        ],
        homework: [
            { key: 'hw_memorize', label: 'Memorize', placeholder: 'Memorize what? e.g. "verses 11-15, 5x daily"' },
            { key: 'hw_revise', label: 'Revise', placeholder: 'Revise what? e.g. "Surah Al-Fajr"' },
            { key: 'hw_apply_tajweed', label: 'Apply Tajweed in assigned verses', placeholder: 'Which verses? e.g. "Madd in Al-Mulk 1-10"' },
        ],
    },
    recitation_tajweed: {
        name: 'Recitation & Tajweed',
        activities: [
            { key: 'recite_prac', label: 'Recitation practice', placeholder: 'Which surah / verses? e.g. "Al-Balad with Tajweed"' },
            { key: 'taj_theory', label: 'Tajweed rule — theory', placeholder: 'Which rule? e.g. "Madd Munfasil definition"' },
            { key: 'taj_apply', label: 'Tajweed rule — application in reading', placeholder: 'Where applied? e.g. "Madd Tabee\'i in Al-Asr"' },
            { key: 'makharij', label: 'Pronunciation / Makharij', placeholder: 'Which letters? e.g. "Qaf, Daad"' },
            { key: 'recurring_mistakes', label: 'Correcting recurring mistakes', placeholder: 'What? e.g. "mixing Sa and Sad"' },
            { key: 'fluency', label: 'Fluency & flow practice', placeholder: 'On what? e.g. "short surahs"' },
        ],
        homework: [
            { key: 'hw_practice_recite', label: 'Practice recitation', placeholder: 'Which verses? e.g. "Al-Balad first 10"' },
            { key: 'hw_practice_taj', label: 'Practice a Tajweed rule', placeholder: 'Which rule? e.g. "Madd in assigned verses"' },
            { key: 'hw_listen_imitate', label: 'Listen & imitate', placeholder: 'Link? e.g. "Al-Husary — Al-Balad"' },
        ],
    },
    ijazah_memorization: {
        name: 'Ijazah Memorization',
        activities: [
            { key: 'ij_recite_memory', label: 'Recite from memory to sheikh', placeholder: 'Surah / juz? e.g. "Juz Amma"' },
            { key: 'ij_sanad_itqan_m', label: 'Sanad-standard recitation (Itqan)', placeholder: 'Portion? e.g. "Al-Fatiha to Al-Baqarah 50"' },
            { key: 'ij_memory_slips', label: 'Correcting memory slips', placeholder: 'Where? e.g. "Al-Baqarah verses 20-30"' },
            { key: 'ij_cert_revision', label: 'Revision of certified portions', placeholder: 'What? e.g. "Juz 1 full revision"' },
        ],
        homework: [
            { key: 'ij_prepare_next', label: 'Prepare next portion', placeholder: 'Surah / verses? e.g. "Al-Baqarah 51-100"' },
            { key: 'ij_perfect_assigned', label: 'Perfect assigned portion', placeholder: 'What? e.g. "remove hesitation in Juz 1"' },
            { key: 'ij_self_record', label: 'Self-record & review', placeholder: 'What? e.g. "record Juz Amma, send to teacher"' },
        ],
    },
    ijazah_recitation: {
        name: 'Ijazah Recitation',
        activities: [
            { key: 'ij_mushaf_nazar', label: 'Recitation from the Mushaf (Nazar)', placeholder: 'Surah / verses? e.g. "Al-Baqarah 1-50"' },
            { key: 'ij_tajweed_sight', label: 'Tajweed mastery in sight-reading', placeholder: 'Focus? e.g. "Madd accuracy"' },
            { key: 'ij_r_recurring_mistakes', label: 'Correcting recurring mistakes', placeholder: 'What? e.g. "mixing Sa and Sad"' },
            { key: 'ij_sanad_itqan_r', label: 'Sanad-standard reading (Itqan)', placeholder: 'Portion? e.g. "Al-Fatiha + first quarter of Al-Baqarah"' },
        ],
        homework: [
            { key: 'ij_r_prepare_next', label: 'Prepare next portion', placeholder: 'Surah / verses? e.g. "Al-Baqarah 51-100"' },
            { key: 'ij_r_perfect_assigned', label: 'Perfect assigned portion', placeholder: 'What? e.g. "perfect Madd in Juz 1"' },
            { key: 'ij_r_self_record', label: 'Self-record & review', placeholder: 'What? e.g. "record assigned portion daily"' },
        ],
    },
    qiraat: {
        name: "Advanced Qira'at",
        activities: [
            { key: 'talaqqi', label: 'Talaqqi (receiving recitation)', placeholder: 'Narration / reciter? e.g. "Hafs from Asim"' },
            { key: 'shatibiyyah', label: 'Reading from Ash-Shatibiyyah', placeholder: 'Which lines? e.g. "lines 1-10"' },
            { key: 'points_diff', label: 'Applying points of difference', placeholder: 'Position? e.g. "Al-Fatiha word 5"' },
            { key: 'narration_rev', label: 'Revision of a narration', placeholder: 'What? e.g. "Warsh from Nafi review"' },
            { key: 'matn_mem', label: 'Memorizing from the Matn', placeholder: 'Which lines? e.g. "Shatibiyyah lines 11-20"' },
            { key: 'surah_in_narration', label: 'Reciting a surah in a narration', placeholder: 'Surah + narration? e.g. "Al-Fatiha in Warsh"' },
        ],
        homework: [
            { key: 'hw_review_matn', label: 'Review the Matn', placeholder: 'Which lines? e.g. "lines 1-20 of Shatibiyyah"' },
            { key: 'hw_prep_points', label: 'Prepare the points of difference', placeholder: 'What? e.g. "Madd differences between Hafs and Warsh"' },
            { key: 'hw_recite_narration', label: 'Recite in assigned narration', placeholder: 'What? e.g. "Al-Fatiha in Qalun"' },
        ],
    },
    understanding: {
        name: 'Quranic Understanding',
        activities: [
            { key: 'tafsir_verses', label: 'Tafsir of surah / verses', placeholder: 'Surah + verses? e.g. "Al-Baqarah verses 1-5"' },
            { key: 'meanings_lessons', label: 'Meanings & lessons', placeholder: 'Topic? e.g. "patience in trials"' },
            { key: 'connecting_verses', label: 'Connecting verses to previous lessons', placeholder: 'What? e.g. "linking to Al-Imran 200"' },
            { key: 'quran_vocab', label: 'Quranic vocabulary / grammar', placeholder: 'What? e.g. "verb forms in Al-Baqarah"' },
            { key: 'tadabbur', label: 'Reflection & discussion (Tadabbur)', placeholder: 'Topic? e.g. "names of Allah in Al-Fatiha"' },
            { key: 'arguments', label: 'Logic & arguments in the verses', placeholder: 'Topic? e.g. "proofs of monotheism in Al-Ikhlas"' },
        ],
        homework: [
            { key: 'hw_prep_verses', label: 'Prepare next verses', placeholder: 'Which? e.g. "Al-Baqarah verses 6-10"' },
            { key: 'hw_reflect', label: 'Reflect on meanings', placeholder: 'Topic? e.g. "names of Allah covered this week"' },
            { key: 'hw_review_vocab_u', label: 'Review vocabulary', placeholder: 'What? e.g. "verbs from this week"' },
        ],
    },
    arabic: {
        name: 'Arabic Language',
        activities: [
            { key: 'new_vocab', label: 'New vocabulary', placeholder: 'Theme / words? e.g. "family members"' },
            { key: 'grammar_rule', label: 'Grammar rule (Nahw / Sarf)', placeholder: 'Which rule? e.g. "definite article (al-)"' },
            { key: 'conversation', label: 'Conversation practice', placeholder: 'Topic? e.g. "introducing yourself"' },
            { key: 'reading_comp', label: 'Reading comprehension', placeholder: 'Text? e.g. "page 12 of textbook"' },
            { key: 'writing_prac', label: 'Writing practice', placeholder: 'What? e.g. "5 sentences about your day"' },
            { key: 'listening_prac', label: 'Listening practice', placeholder: 'What? e.g. "audio dialogue 3"' },
        ],
        homework: [
            { key: 'hw_review_grammar', label: 'Review vocabulary / rule', placeholder: 'What? e.g. "this week\'s new verbs"' },
            { key: 'hw_practice_convo', label: 'Practice conversation / writing', placeholder: 'What? e.g. "5 sentences about hobbies"' },
            { key: 'hw_read_text', label: 'Read assigned text', placeholder: 'What? e.g. "story 1 from reader"' },
        ],
    },
    islamic: {
        name: 'Islamic Studies',
        activities: [
            { key: 'fiqh', label: 'Fiqh topic', placeholder: 'Which topic? e.g. "wudu rules"' },
            { key: 'seerah', label: 'Seerah', placeholder: 'Event / period? e.g. "Hijrah to Madinah"' },
            { key: 'aqeedah', label: 'Aqeedah', placeholder: 'Topic? e.g. "belief in angels"' },
            { key: 'dua_hadith', label: 'Dua / hadith memorization', placeholder: 'What? e.g. "morning duas"' },
            { key: 'akhlaq', label: 'Akhlaq & manners', placeholder: 'Topic? e.g. "respecting parents"' },
            { key: 'story_lesson', label: 'Story / lesson discussion', placeholder: 'Topic? e.g. "story of Prophet Yusuf"' },
        ],
        homework: [
            { key: 'hw_review_topic', label: 'Review the topic', placeholder: 'What? e.g. "wudu steps"' },
            { key: 'hw_memorize_dua', label: 'Memorize dua / hadith', placeholder: 'What? e.g. "dua before eating"' },
            { key: 'hw_prep_next_topic', label: 'Read / prepare next topic', placeholder: 'What? e.g. "next chapter on prayer"' },
        ],
    },
    kids: {
        name: 'Kids',
        activities: [
            { key: 'letters_sounds', label: 'Letters & sounds', placeholder: 'Which letters / sounds? e.g. "Alif, Baa, Taa with Fatha"' },
            { key: 'k_new_mem', label: 'New memorization (short surah)', placeholder: 'Which surah? e.g. "Surah An-Nas"' },
            { key: 'k_reading_prac', label: 'Reading practice', placeholder: 'What? e.g. "page 5 from Noorani Qaeda"' },
            { key: 'k_new_words', label: 'New words / simple Arabic', placeholder: 'What? e.g. "colors in Arabic"' },
            { key: 'k_fun_activity', label: 'Fun activity / game', placeholder: 'What? e.g. "Quran flashcards game"' },
            { key: 'k_last_lesson_rev', label: 'Revision of last lesson', placeholder: 'What? e.g. "letters from last week"' },
        ],
        homework: [
            { key: 'k_hw_with_parent', label: 'Practice with a parent', placeholder: 'What? e.g. "read pages 5-7 with mom"' },
            { key: 'k_hw_video', label: 'Watch / repeat (video)', placeholder: 'Link? e.g. "YouTube: Surah An-Nas tutorial"' },
            { key: 'k_hw_simple_review', label: 'Simple review', placeholder: 'What? e.g. "letters Alif-Jeem"' },
        ],
    },
};

const COURSE_TO_GROUP = {
    'Noorani Qaeda': 'foundational_reading',
    "Qur'an Memorization With Tajweed": 'memorization',
    'Quran Memorization With Tajweed': 'memorization',
    "Qur'an Recitation with Tajweed": 'recitation_tajweed',
    'Quran Recitation with Tajweed': 'recitation_tajweed',
    'Tajweed Course': 'recitation_tajweed',
    'Ijazah Memorization': 'ijazah_memorization',
    'Ijazah — Memorization': 'ijazah_memorization',
    'Ijazah - Memorization': 'ijazah_memorization',
    'Ijazah Recitation': 'ijazah_recitation',
    'Ijazah — Recitation': 'ijazah_recitation',
    'Ijazah - Recitation': 'ijazah_recitation',
    'Ten Qirat Course': 'qiraat',
    "Ten Qira'at Course": 'qiraat',
    'Quran Tafseer': 'understanding',
    'Quran Tafseer Course': 'understanding',
    'Quranic Arabic': 'understanding',
    'Arabic Conversation': 'arabic',
    'Arabic Grammar': 'arabic',
    'General Arabic': 'arabic',
    'Islamic Studies': 'islamic',
    'Islamic Studies for Kids & Beginners': 'islamic',
    'Quran for Kids': 'kids',
    'Arabic for Kids': 'kids',
};

function fuzzyGroupKey(name){
    const lower = (name || '').toLowerCase();
    if (!lower) return 'recitation_tajweed';
    if (lower.includes('noorani') || lower.includes('qaeda')) return 'foundational_reading';
    if (lower.includes('ijazah') && (lower.includes('memor') || lower.includes('hifz'))) return 'ijazah_memorization';
    if (lower.includes('ijazah')) return 'ijazah_recitation';
    if (lower.includes('qira') || lower.includes("qira'")) return 'qiraat';
    if (lower.includes('tafs')) return 'understanding';
    if (lower.includes('quranic arabic')) return 'understanding';
    if (lower.includes('kids') || lower.includes('child')) return 'kids';
    if (lower.includes('memor') || lower.includes('hifz')) return 'memorization';
    if (lower.includes('islamic') || lower.includes('fiqh') || lower.includes('seerah')) return 'islamic';
    if (lower.includes('arabic')) return 'arabic';
    if (lower.includes('recitation') || lower.includes('tajweed')) return 'recitation_tajweed';
    return 'recitation_tajweed';
}

export function getGroupForCourse(courseName){
    const key = COURSE_TO_GROUP[courseName] || fuzzyGroupKey(courseName);
    return GROUPS[key] || GROUPS.recitation_tajweed;
}

export { GROUPS };

function chipBullet(chip){
    const label = String(chip.label || '').trim();
    const detail = String(chip.detail || '').trim();
    return detail ? `• ${label} — ${detail}` : `• ${label}`;
}

export function composeClassActivity(activityChips, other, engagement){
    const lines = [];
    (activityChips || []).forEach(c => { lines.push(chipBullet(c)); });
    const otherText = String(other || '').trim();
    if (otherText) lines.push(`• ${otherText}`);
    let prose = lines.join('\n');
    if (engagement){
        const e = String(engagement).toLowerCase().replace(/ today$/, '');
        if (prose) prose += '\n\n';
        prose += `The student showed ${e} throughout the session.`;
    }
    return prose;
}

export function composeHomework(homeworkChips, other){
    const lines = [];
    (homeworkChips || []).forEach(c => { lines.push(chipBullet(c)); });
    const otherText = String(other || '').trim();
    if (otherText) lines.push(`• ${otherText}`);
    if (lines.length === 0) return '';
    return 'Before our next class, please complete the following:\n' + lines.join('\n');
}

function splitLabelDetail(line){
    // Split on " — " (em dash) or " - " (hyphen with spaces)
    const dashRe = / [—-] /;
    const m = line.match(dashRe);
    if (m){
        const idx = line.indexOf(m[0]);
        return {
            label: line.substring(0, idx).trim(),
            detail: line.substring(idx + m[0].length).trim(),
        };
    }
    return { label: line.trim(), detail: '' };
}

function findEngagement(prose){
    const m = String(prose || '').match(/The student showed (.+?) throughout the session\./);
    if (!m) return { engagement: '', strippedProse: prose };
    const text = m[1].trim().toLowerCase();
    const found = ENGAGEMENT_CHIPS.find(e => {
        const e1 = e.toLowerCase();
        const e2 = e1.replace(/ today$/, '');
        return e1 === text || e2 === text;
    });
    const strippedProse = String(prose).replace(m[0], '').trim();
    return { engagement: found || '', strippedProse };
}

export function parseActivityProse(prose, group){
    const result = { activityChips: [], activityOther: '', engagement: '' };
    if (!prose) return result;

    const { engagement, strippedProse } = findEngagement(prose);
    result.engagement = engagement;

    const segments = parseReportProse(strippedProse);
    const bulletSegments = segments.filter(s => s.type === 'bullets');
    const paraSegments = segments.filter(s => s.type === 'para');
    const otherLines = [];

    if (bulletSegments.length){
        bulletSegments.forEach(seg => {
            seg.content.forEach(line => {
                const { label, detail } = splitLabelDetail(line);
                const chip = (group.activities || []).find(c => c.label === label);
                if (chip){
                    result.activityChips.push({
                        key: chip.key,
                        label: chip.label,
                        placeholder: chip.placeholder,
                        detail: detail,
                    });
                } else {
                    otherLines.push(detail ? `${label} — ${detail}` : label);
                }
            });
        });
        // Any non-engagement paragraphs become free-form notes
        paraSegments.forEach(p => otherLines.push(p.content));
    } else {
        // No bullets — old free-text report. Dump the prose into "other" so the teacher can re-edit.
        if (strippedProse.trim()) otherLines.push(strippedProse.trim());
    }
    result.activityOther = otherLines.join('\n');
    return result;
}

export function parseHomeworkProse(prose, group){
    const result = { homeworkChips: [], homeworkOther: '' };
    if (!prose) return result;

    const cleaned = String(prose).replace(/^Before our next class, please complete the following:\s*\n?/i, '').trim();
    const segments = parseReportProse(cleaned);
    const bulletSegments = segments.filter(s => s.type === 'bullets');
    const paraSegments = segments.filter(s => s.type === 'para');
    const otherLines = [];

    if (bulletSegments.length){
        bulletSegments.forEach(seg => {
            seg.content.forEach(line => {
                const { label, detail } = splitLabelDetail(line);
                const chip = (group.homework || []).find(c => c.label === label);
                if (chip){
                    result.homeworkChips.push({
                        key: chip.key,
                        label: chip.label,
                        placeholder: chip.placeholder,
                        detail: detail,
                    });
                } else {
                    otherLines.push(detail ? `${label} — ${detail}` : label);
                }
            });
        });
        paraSegments.forEach(p => otherLines.push(p.content));
    } else {
        if (cleaned) otherLines.push(cleaned);
    }
    result.homeworkOther = otherLines.join('\n');
    return result;
}

// Split a saved report string into ordered segments of paragraphs and bullet lists.
// Lines starting with "• " are bullets; blank lines end the current segment.
// Returns: [{ type: 'para', content: string } | { type: 'bullets', content: string[] }]
export function parseReportProse(text){
    const segments = [];
    if (!text) return segments;
    const lines = String(text).split('\n');
    let current = null;
    lines.forEach(raw => {
        const line = raw.replace(/\s+$/, '');
        const trimmed = line.trim();
        if (trimmed === ''){
            current = null;
            return;
        }
        const bulletMatch = trimmed.match(/^[•·\-*]\s+(.*)$/);
        if (bulletMatch){
            const item = bulletMatch[1].trim();
            if (current && current.type === 'bullets'){
                current.content.push(item);
            } else {
                current = { type: 'bullets', content: [item] };
                segments.push(current);
            }
        } else {
            if (current && current.type === 'para'){
                current.content += '\n' + trimmed;
            } else {
                current = { type: 'para', content: trimmed };
                segments.push(current);
            }
        }
    });
    return segments;
}
